export const CARD_W = 320;
export const CARD_H = 178;

export const ROUND_GAP = 136;
export const BASE_MATCH_GAP = 46;

export const TOP_OFFSET = 106;
export const VIEW_PADDING_X = 30;
export const VIEW_PADDING_BOTTOM = 64;

export const BASE_STEP = CARD_H + BASE_MATCH_GAP;

export const getMatchCenterY = (roundIndex, matchIndex) => {
  const multiplier = Math.pow(2, roundIndex);
  const offset = (multiplier - 1) / 2;

  return (
    TOP_OFFSET +
    CARD_H / 2 +
    (matchIndex * multiplier + offset) * BASE_STEP
  );
};

export const getMatchPosition = (roundIndex, matchIndex) => {
  const x = VIEW_PADDING_X + roundIndex * (CARD_W + ROUND_GAP);
  const y = getMatchCenterY(roundIndex, matchIndex) - CARD_H / 2;

  return { x, y };
};

export const getBoardSize = (rounds, seed) => {
  const baseSize = Math.max(2, seed.length);
  const baseMatchCount = Math.max(1, Math.ceil(baseSize / 2));

  const width =
    VIEW_PADDING_X * 2 +
    rounds.length * CARD_W +
    Math.max(0, rounds.length - 1) * ROUND_GAP;

  const height =
    TOP_OFFSET +
    (baseMatchCount - 1) * BASE_STEP +
    CARD_H +
    VIEW_PADDING_BOTTOM;

  return { width, height };
};